import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import LandingPage from './components/LandingPage';
import MemoryInput from './components/MemoryInput';
import PastMemories from './components/PastMemories';
import MemoryPalace from './components/MemoryPalace';
import MemoryRegeneration from './components/MemoryRegeneration';
import EnhancedJournaling from './components/EnhancedJournaling';
import MindPalaceVisualizer from './components/MindPalaceVisualizer';

function App() {
  const handleMemorySubmit = (memoryData) => {
    // Get existing memories
    const memories = JSON.parse(localStorage.getItem('memories') || '[]');
    
    // Add new memory with unique ID
    const newMemory = {
      id: Date.now(),
      ...memoryData,
      createdAt: new Date().toISOString()
    };
    
    // Save to localStorage
    localStorage.setItem('memories', JSON.stringify([...memories, newMemory]));
  };

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Palace in Wonderland</h1>
          <Navigation />
        </header>
        
        <main className="App-main">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/new-memory" element={<MemoryInput onMemorySubmit={handleMemorySubmit} />} />
            <Route path="/past-memories" element={<PastMemories />} />
            <Route path="/memory/:id" element={<MemoryPalace />} />
            <Route path="/memory-regeneration" element={<MemoryRegeneration />} />
            <Route path="/enhanced-journaling" element={<EnhancedJournaling />} />
            <Route path="/mind-palace" element={<MindPalaceVisualizer />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
